import { init, exec } from 'pell';
import abort from '../../../javascripts/utils/abort';

const usePell = async ($input: HTMLInputElement) => {
  const { richtext } = $input.dataset;

  if (!richtext) {
    return;
  }

  const $richtext = document.getElementById(richtext) ?? abort();

  const actions: pell.pellAction[] = [];
  $richtext
    .querySelectorAll<HTMLButtonElement>('.input__richtext-toolbar-button')
    .forEach(($button) => {
      const { exec: name } = $button.dataset;
      const mapped: Record<
        string,
        { result: () => boolean; state?: () => boolean }
      > = {
        alignleft: {
          result: () => {
            exec('justifyLeft', '');
            return true;
          },
          state: () => document.queryCommandState('justifyLeft'),
        },
        alignright: {
          result: () => {
            exec('justifyRight', '');
            return true;
          },
          state: () => document.queryCommandState('justifyRight'),
        },
        aligncenter: {
          result: () => {
            exec('justifyCenter', '');
            return true;
          },
          state: () => document.queryCommandState('justifyCenter'),
        },
      };

      if (name === 'clear') {
        const action: pell.pellCustomActionConfig = {
          name,
          icon: $button.innerHTML.trim(),
          title: $button.title,
          result: () => {
            const selection = window.getSelection()?.toString();

            if (selection) {
              const linesToDelete = selection.split('\n').join('<br>');
              exec('formatBlock', '<p>');
              document.execCommand('insertHTML', false, linesToDelete);
            } else {
              exec('formatBlock', '<p>');
            }

            return true;
          },
        };

        actions.push(action);
      } else if (name && name in mapped) {
        const action: pell.pellCustomActionConfig = {
          name,
          icon: $button.innerHTML.trim(),
          title: $button.title,
          // eslint-disable-next-line security/detect-object-injection
          ...mapped[name], // nosemgrep: eslint.detect-object-injection
        };

        actions.push(action);
      } else if (name) {
        const action: pell.pellActionConfig = {
          name: name as pell.pellAction,
          icon: $button.innerHTML.trim(),
          title: $button.title,
        };

        actions.push(action);
      }
    });

  $richtext.querySelector('.input__richtext-toolbar')?.remove();
  $richtext.querySelector('.input__richtext-content')?.remove();

  const editor = init({
    element: $richtext,
    defaultParagraphSeparator: 'p',
    actions,
    styleWithCSS: false,
    onChange: (html) => {
      $input.value = html;
    },
    classes: {
      actionbar: 'input__richtext-toolbar',
      button: 'input__richtext-toolbar-button',
      selected: 'input__richtext-toolbar-button--selected',
      content: 'input__richtext-content',
    },
  });

  setTimeout(() => {
    if ($input.value) {
      editor.content.innerHTML = $input.value;
      editor.content.dispatchEvent(new MouseEvent('mouseup'));
    }
  }, 1);

  $richtext
    .querySelectorAll('.input__richtext-toolbar-button')
    .forEach(($button) => {
      $button.addEventListener('mousedown', (e) => e.preventDefault());
      $button.addEventListener('mouseup', () => {
        setTimeout(() => {
          editor.content.dispatchEvent(new MouseEvent('mouseup'));
        }, 1);
      });
    });
};

export default usePell;
